/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatsAccuracy } from './StatsAccuracy';
import {
    StatsAccuracyFromJSON,
    StatsAccuracyFromJSONTyped,
    StatsAccuracyToJSON,
    StatsAccuracyToJSONTyped,
} from './StatsAccuracy';
import type { StatsAgreement } from './StatsAgreement';
import {
    StatsAgreementFromJSON,
    StatsAgreementFromJSONTyped,
    StatsAgreementToJSON,
    StatsAgreementToJSONTyped,
} from './StatsAgreement';

/**
 * 
 * @export
 * @interface StatsBucket
 */
export interface StatsBucket {
    /**
     * 
     */
    submissions: number;
    /**
     * 
     */
    byStatus: { [key: string]: number; };
    /**
     * 
     */
    senders: number;
    /**
     * 
     */
    guideSenders: number;
    /**
     * 
     */
    teamSenders: number;
    /**
     * 
     */
    withFeedback: number;
    /**
     * 
     */
    feedbackMeasurement: number;
    /**
     * 
     */
    feedbackConfirmed: number;
    /**
     * 
     */
    feedbackAgreed: number;
    /**
     * 
     */
    feedbackDisagreed: number;
    /**
     * 
     */
    feedbackChatter: number;
    /**
     * 
     */
    length: StatsAccuracy | null;
    /**
     * 
     */
    girth: StatsAccuracy | null;
    /**
     * 
     */
    weight: StatsAccuracy | null;
    /**
     * 
     */
    speciesAgreement: StatsAgreement | null;
}

/**
 * Check if a given object implements the StatsBucket interface.
 */
export function instanceOfStatsBucket(value: object): value is StatsBucket {
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    if ((!('byStatus' in (value as Record<string, any>)) && !('by_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['byStatus'] === undefined && (value as Record<string, any>)['by_status'] === undefined)) return false;
    if (!('senders' in value) || value['senders'] === undefined) return false;
    if ((!('guideSenders' in (value as Record<string, any>)) && !('guide_senders' in (value as Record<string, any>))) || ((value as Record<string, any>)['guideSenders'] === undefined && (value as Record<string, any>)['guide_senders'] === undefined)) return false;
    if ((!('teamSenders' in (value as Record<string, any>)) && !('team_senders' in (value as Record<string, any>))) || ((value as Record<string, any>)['teamSenders'] === undefined && (value as Record<string, any>)['team_senders'] === undefined)) return false;
    if ((!('withFeedback' in (value as Record<string, any>)) && !('with_feedback' in (value as Record<string, any>))) || ((value as Record<string, any>)['withFeedback'] === undefined && (value as Record<string, any>)['with_feedback'] === undefined)) return false;
    if ((!('feedbackMeasurement' in (value as Record<string, any>)) && !('feedback_measurement' in (value as Record<string, any>))) || ((value as Record<string, any>)['feedbackMeasurement'] === undefined && (value as Record<string, any>)['feedback_measurement'] === undefined)) return false;
    if ((!('feedbackConfirmed' in (value as Record<string, any>)) && !('feedback_confirmed' in (value as Record<string, any>))) || ((value as Record<string, any>)['feedbackConfirmed'] === undefined && (value as Record<string, any>)['feedback_confirmed'] === undefined)) return false;
    if ((!('feedbackAgreed' in (value as Record<string, any>)) && !('feedback_agreed' in (value as Record<string, any>))) || ((value as Record<string, any>)['feedbackAgreed'] === undefined && (value as Record<string, any>)['feedback_agreed'] === undefined)) return false;
    if ((!('feedbackDisagreed' in (value as Record<string, any>)) && !('feedback_disagreed' in (value as Record<string, any>))) || ((value as Record<string, any>)['feedbackDisagreed'] === undefined && (value as Record<string, any>)['feedback_disagreed'] === undefined)) return false;
    if ((!('feedbackChatter' in (value as Record<string, any>)) && !('feedback_chatter' in (value as Record<string, any>))) || ((value as Record<string, any>)['feedbackChatter'] === undefined && (value as Record<string, any>)['feedback_chatter'] === undefined)) return false;
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('girth' in value) || value['girth'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if ((!('speciesAgreement' in (value as Record<string, any>)) && !('species_agreement' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesAgreement'] === undefined && (value as Record<string, any>)['species_agreement'] === undefined)) return false;
    return true;
}

export function StatsBucketFromJSON(json: any): StatsBucket {
    return StatsBucketFromJSONTyped(json, false);
}

export function StatsBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'submissions': json['submissions'],
        'byStatus': json['by_status'],
        'senders': json['senders'],
        'guideSenders': json['guide_senders'],
        'teamSenders': json['team_senders'],
        'withFeedback': json['with_feedback'],
        'feedbackMeasurement': json['feedback_measurement'],
        'feedbackConfirmed': json['feedback_confirmed'],
        'feedbackAgreed': json['feedback_agreed'],
        'feedbackDisagreed': json['feedback_disagreed'],
        'feedbackChatter': json['feedback_chatter'],
        'length': StatsAccuracyFromJSON(json['length']),
        'girth': StatsAccuracyFromJSON(json['girth']),
        'weight': StatsAccuracyFromJSON(json['weight']),
        'speciesAgreement': StatsAgreementFromJSON(json['species_agreement']),
    };
}

export function StatsBucketToJSON(json: any): StatsBucket {
    return StatsBucketToJSONTyped(json, false);
}

export function StatsBucketToJSONTyped(value?: StatsBucket | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissions': value['submissions'],
        'by_status': value['byStatus'],
        'senders': value['senders'],
        'guide_senders': value['guideSenders'],
        'team_senders': value['teamSenders'],
        'with_feedback': value['withFeedback'],
        'feedback_measurement': value['feedbackMeasurement'],
        'feedback_confirmed': value['feedbackConfirmed'],
        'feedback_agreed': value['feedbackAgreed'],
        'feedback_disagreed': value['feedbackDisagreed'],
        'feedback_chatter': value['feedbackChatter'],
        'length': StatsAccuracyToJSON(value['length']),
        'girth': StatsAccuracyToJSON(value['girth']),
        'weight': StatsAccuracyToJSON(value['weight']),
        'species_agreement': StatsAgreementToJSON(value['speciesAgreement']),
    };
}

